import { Environment } from "./Environment";
import { IMessageAnalytics } from "../interfaces/IMessageAnalytics";
import { IMobileDevicesAnalytics } from "../interfaces/IMobileDevicesAnalytics";
import { IHttpStatus } from "../interfaces/IHttpStatus";
import { FetchProxy } from "intraactive-sdk-helper";
import { sdkContainerInstance } from "../global/Container";
import { INavigatorClickDictionary } from "../interfaces/INavigatorClickDictionary";


export default class AnalyticsService {
  public static getMessages(environment: "Development" | "Test" | "Production", token: string, tenant: string, fromDate: string, toDate: string, source?: "total" | "web" | "mobile" | "android" | "ios"): Promise<IMessageAnalytics[]> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/messages/aggregated/${source}?fromDate=${fromDate}&toDate=${toDate}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static getRegisteredMobileDevices(environment: "Development" | "Test" | "Production", token: string, tenant: string, fromDate: string, toDate: string): Promise<IMobileDevicesAnalytics[]> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/report/registered-mobile-devices?From=${fromDate}&To=${toDate}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Headers': 'AuthToken, token, content-type'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static getBySourceRollup(environment: "Development" | "Test" | "Production", token: string, tenant: string, instance: string, fromDate: string, toDate: string, messageIds: number[], source: "total" | "web" | "mobile" | "android" | "ios"): Promise<{ httpStatus: IHttpStatus, value?: IMessageAnalytics[] }> {
    return new Promise((resolve) => {
      const messageIdsString = messageIds.join(",");
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/messages/aggregated/${source}/rollup/instance/${instance}/?fromDate=${fromDate}&toDate=${toDate}&messageIds=${messageIdsString}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              resolve({
                httpStatus: {
                  statusCode: response.status,
                  message: response.statusText
                }
              });
              return;
            } else {
              return response.json();
            }
          }).then(result => {
            resolve({
              httpStatus: {
                statusCode: 200,
              },
              value: result
            });
          }).catch(error => {
            console.log(error);
            resolve({
              httpStatus: {
                statusCode: error.status,
                message: error.statusText
              }
            });
          });
      } else {
        resolve({
          httpStatus: {
            statusCode: 400,
            message: "Missing parameter"
          }
        });
      }
    });
  }

  public static getUniqueViewsDirectlyFromAppInsights(environment: "Development" | "Test" | "Production", token: string, tenant: string, instance: string, messageId: number): Promise<{ uniqueViews: number }> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/instance/${instance}/${messageId}/get-unique-views/`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }

  public static downloadExcelExport(environment: "Development" | "Test" | "Production", token: string, tenant: string, instanceName: string, category: string, fromDate: string, toDate: string, source: "total" | "web" | "mobile" | "android" | "ios"): void {
    const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/messages/aggregated/${source}/export/?fromDate=${fromDate}&toDate=${toDate}&AuthToken=${token}&instanceName=${instanceName}&category=${category}`;
    document.location.assign(apiUrl);
  }

  public static downloadExcelExportNavigator(environment: "Development" | "Test" | "Production", token: string, tenant: string, instanceName: string, fromDate: string, toDate: string, source: "total" | "web" | "mobile" | "android" | "ios"): Promise<void> {
    return new Promise((resolve, reject) => {
    const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/navigator/aggregated/${source}/export/?fromDate=${fromDate}&toDate=${toDate}&instanceName=${instanceName}`;
    new FetchProxy(apiUrl, {
      method: "GET",
      credentials: "same-origin",
      mode: "cors",
      headers: new Headers({
        "AuthToken": token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    }).withContainer(sdkContainerInstance)
      .fetch()
      .then((response => 
        response.blob()))
      .then((data) => {
        var url = window.URL.createObjectURL(data);
        var a = document.createElement('a');
        a.href = url;
        a.download = `IntraActiveAnalytics-${instanceName}-${fromDate}-${toDate}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        resolve();
      }).catch(error => {
        console.log(error);
        reject();
      });
    });
  }

  public static getNavigatorClicks(environment: "Development" | "Test" | "Production", token: string, tenant: string, instanceName: string, fromDate: string, toDate: string): Promise<INavigatorClickDictionary> {
    return new Promise((resolve) => {
      if (environment && tenant && token) {
        const apiUrl = `${Environment.getEnvironmentForAnalyticsAPI(environment)}/${tenant.replace(".sharepoint.com", "")}/navigator/aggregated/?fromDate=${fromDate}&toDate=${toDate}&instanceName=${instanceName}`;
        new FetchProxy(apiUrl, {
          method: "GET",
          credentials: "same-origin",
          mode: "cors",
          headers: new Headers({
            "AuthToken": token,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          })
        }).withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              return response.status;
            } else {
              return response.json()
            }
          }).then(response => {
            resolve(response);
          }).catch(error => {
            console.log(error);
          });
      } else {
        resolve(null);
      }
    });
  }
}